/* Titanium site-wide cart helpers (load from theme.liquid).
   1) Plan guard: subscription tiers depend on how many boxes share a plan
      (12 packs = 1 box, 24 packs = 2, 36 packs = 3). When the cart changes
      (a flavor removed, a quantity changed), every group of subscription boxes
      is moved to the Recharge plan that matches its real size, so price and
      discount always match what is in the cart.
   2) Free shipping label for subscriptions in the One Click Upsell drawer (display only). */
(function(){
  if(window.__tcpCart)return;window.__tcpCart=1;
  /* 0) No hover mini cart: the header cart icon only opens the drawer on click.
     Hides the Turbo theme hover dropdown (.cart_content) everywhere. */
  (function(){try{var h=document.createElement('style');h.id='tcp-nohover-cart';h.textContent=
    '.cart-container .cart_content,.cart_container .cart_content,.header .cart_content,.sticky_nav .cart_content,.tos_warning.cart_content,.mini_cart+.cart_content,.cart-container.active_link>.cart_content,.cart-container:hover .cart_content{display:none!important;visibility:hidden!important;opacity:0!important;pointer-events:none!important}';
    (document.head||document.documentElement).appendChild(h)}catch(e){}})();
  var ROOT=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  var PACKS_PER_BOX=12, MAX_BOXES=3;               /* tiers: 12, 24, 36 packs */
  var PLAN_RE=/(\d+)\s*packs?/i;                    /* reads "24 packs \u00b7 Monthly delivery" */
  var nativeFetch=window.fetch.bind(window);
  function j(url,opt){return nativeFetch(ROOT+url,Object.assign({headers:{'Accept':'application/json','Content-Type':'application/json'}},opt||{})).then(function(r){return r.json()})}
  var products={};
  function product(handle){if(!products[handle])products[handle]=j('products/'+handle+'.js');return products[handle]}
  function planPacks(name){var m=String(name||'').match(PLAN_RE);return m?+m[1]:0}
  function itemPlan(it){var a=it.selling_plan_allocation;return a&&a.selling_plan?a.selling_plan:null}

  /* ---------- on-brand "updating" overlay ---------- */
  var BUSY_T='Recalculating', BUSY_S='Matching your plan and savings to what\u2019s inside';
  var busyEl=null,busyTimer=null;
  function showBusy(){
    if(!busyEl){
      var st=document.createElement('style');st.textContent=
        '.tcp-busy{position:fixed;inset:0;z-index:2147483646;display:grid;place-items:center;background:rgba(15,27,34,.35);backdrop-filter:blur(2px);-webkit-backdrop-filter:blur(2px);opacity:0;transition:opacity .2s;pointer-events:auto}'+
        '.tcp-busy.is-on{opacity:1}'+
        '.tcp-busy-card{display:grid;justify-items:center;gap:10px;min-width:260px;max-width:88vw;padding:26px 30px 24px;border-radius:20px;background:#1C2B38;color:#fff;text-align:center;box-shadow:0 24px 60px rgba(0,0,0,.35);font-family:Montserrat,"Helvetica Neue",Arial,sans-serif}'+
        '.tcp-busy-peak{width:54px;height:46px;animation:tcp-climb 1.1s ease-in-out infinite}'+
        '.tcp-busy-t{font-weight:800;font-style:italic;font-size:22px;letter-spacing:.01em;margin:0;line-height:1.2}'+
        '.tcp-busy-s{font-size:16px;line-height:1.4;color:#D5DCE3;margin:0;font-family:Roboto,Arial,sans-serif;max-width:340px;text-wrap:balance}'+
        '@media(max-width:600px){.tcp-busy-card{min-width:0;width:calc(100vw - 48px);padding:24px 20px 22px;border-radius:18px}.tcp-busy-t{font-size:20px}.tcp-busy-s{font-size:15px}.tcp-busy-peak{width:46px;height:40px}}'+
        '.tcp-busy-bar{width:180px;height:4px;border-radius:999px;background:rgba(255,255,255,.12);overflow:hidden;margin-top:4px}'+
        '.tcp-busy-bar i{display:block;height:100%;width:40%;border-radius:999px;background:#ED2930;animation:tcp-slide 1.1s ease-in-out infinite}'+
        '@keyframes tcp-climb{0%,100%{transform:translateY(0)}50%{transform:translateY(-6px)}}'+
        '@keyframes tcp-slide{0%{transform:translateX(-110%)}100%{transform:translateX(260%)}}'+
        '@media(prefers-reduced-motion:reduce){.tcp-busy-peak,.tcp-busy-bar i{animation:none}}';
      document.head.appendChild(st);
      busyEl=document.createElement('div');busyEl.className='tcp-busy';busyEl.setAttribute('role','status');busyEl.setAttribute('aria-live','polite');
      busyEl.innerHTML='<div class="tcp-busy-card"><svg class="tcp-busy-peak" viewBox="240 0 120 105" aria-hidden="true"><path d="M245 100 L300 5 L355 100 L323 100 L300 60 L277 100 Z" fill="#ED2930"/></svg><p class="tcp-busy-t">'+BUSY_T+'\u2026</p><p class="tcp-busy-s">'+BUSY_S+'</p><div class="tcp-busy-bar"><i></i></div></div>';
    }
    if(!busyEl.parentNode)document.body.appendChild(busyEl);
    requestAnimationFrame(function(){busyEl.classList.add('is-on')});
    clearTimeout(busyTimer);busyTimer=setTimeout(hideBusy,12000);   /* never leave it stuck */
  }
  function hideBusy(){clearTimeout(busyTimer);if(!busyEl)return;busyEl.classList.remove('is-on');setTimeout(function(){if(busyEl&&!busyEl.classList.contains('is-on')&&busyEl.parentNode)busyEl.parentNode.removeChild(busyEl)},220)}

  /* ---------- 1) plan guard ---------- */
  var running=false,again=false;
  function guard(){
    if(running){again=true;return Promise.resolve()}
    running=true;var changed=false;
    function pass(n){
      if(n>8)return Promise.resolve();
      return j('cart.js').then(function(cart){
        var groups={};
        (cart.items||[]).forEach(function(it){
          var pl=itemPlan(it);if(!pl||!planPacks(pl.name))return;          /* only our tiered subscriptions */
          var key=(it.properties&&it.properties._tcp_bundle)||('line:'+it.key);
          (groups[key]=groups[key]||[]).push(it);
        });
        var todo=null;
        Object.keys(groups).some(function(k){
          var items=groups[k],boxes=items.reduce(function(s,i){return s+i.quantity},0);
          /* "+" adds more units of the same plan (no upgrade). A plan only drops a tier
             when the boxes left are fewer than the plan needs (e.g. a flavor removed). */
          var tier=items.reduce(function(m,i){return Math.max(m,planPacks(itemPlan(i).name))},0);
          var want=boxes*PACKS_PER_BOX<tier?Math.max(boxes,1)*PACKS_PER_BOX:tier;
          var bad=items.filter(function(i){return planPacks(itemPlan(i).name)!==want})[0];
          if(bad){todo={item:bad,want:want};return true}
        });
        if(!todo)return;
        if(!changed&&n===0)showBusy();
        return product(todo.item.handle).then(function(p){
          var cur=itemPlan(todo.item),target=null;
          (p.selling_plan_groups||[]).forEach(function(g){(g.selling_plans||[]).forEach(function(sp){
            if(target||planPacks(sp.name)!==todo.want)return;
            target=sp;
          })});
          if(!target||String(target.id)===String(cur.id))return;
          changed=true;clearAll();
          return j('cart/change.js',{method:'POST',body:JSON.stringify({id:todo.item.key,quantity:todo.item.quantity,selling_plan:target.id})})
            .then(function(){return pass(n+1)});
        });
      });
    }
    return pass(0).catch(function(){}).then(function(){
      running=false;
      if(changed)refreshUI();
      setTimeout(hideBusy,changed?700:0);
      if(again){again=false;return guard()}
    });
  }
  function refreshUI(){
    ['cart:refresh','cart:updated'].forEach(function(e){try{document.dispatchEvent(new CustomEvent(e,{bubbles:true}))}catch(x){}});
    try{window.dispatchEvent(new CustomEvent('ocu:cart:open'))}catch(x){}   /* re-renders the OCU drawer with the new prices */
    if(/\/cart\/?$/.test(location.pathname))location.reload();
    scheduleLabel();
  }
  /* watch every cart request made by the theme or apps */
  var CART_RE=/\/cart\/(change|update|add|clear)(\.js)?/;
  var timer=null;function scheduleGuard(){clearTimeout(timer);timer=setTimeout(guard,250)}
  window.fetch=function(input,init){
    var url=typeof input==='string'?input:(input&&input.url)||'';
    if(CART_RE.test(url))clearAll();
    var pr=nativeFetch(input,init);
    if(CART_RE.test(url))pr.then(function(){scheduleGuard()},function(){});
    return pr;
  };
  var xo=XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open=function(m,url){if(CART_RE.test(url||'')){clearAll();this.addEventListener('loadend',scheduleGuard)}return xo.apply(this,arguments)};

  /* ---------- 2) free shipping label in the drawer ---------- */
  var FREE='FREE', MSG='Your subscription ships free!';
  var PATTERNS=[/calculated at (the )?next step/i,/calculated at checkout/i,/spend \$?[\d.,]+ (more )?for free shipping/i,/away from free shipping/i];
  var cart=null,at=0,busy=false,lt=null;
  function getCart(){if(cart&&Date.now()-at<1500)return Promise.resolve(cart);return j('cart.js').then(function(c){cart=c;at=Date.now();return c})}
  function leaves(){var out=[],w=document.createTreeWalker(document.body,NodeFilter.SHOW_TEXT,null);
    while(w.nextNode()){var n=w.currentNode,t=n.nodeValue;if(!t||t.length>120)continue;
      if(PATTERNS.some(function(p){return p.test(t)})&&!(n.parentElement&&n.parentElement.closest('.tcp')))out.push(n)}return out}
  function label(){var nodes=leaves();if(!nodes.length||busy)return;busy=true;
    getCart().then(function(c){if(c&&c.items&&c.items.some(function(i){return i.selling_plan_allocation}))nodes.forEach(function(n){
      n.nodeValue=/calculated|spend/i.test(n.nodeValue)?FREE:MSG;var el=n.parentElement;if(el)el.style.fontWeight='700'})})
    .catch(function(){}).then(function(){busy=false})}
  function scheduleLabel(){clearTimeout(lt);lt=setTimeout(function(){cart=null;label();savings();upsell()},150)}
  /* ---------- 3) savings in the drawer (per line + total), Magic Mind style ---------- */
  var SAVE_TXT='Savings', OFF_TXT='off';
  function money(c){return '$'+(c/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,',')}
  function css(){
    if(document.getElementById('tcp-sv-css'))return;
    var st=document.createElement('style');st.id='tcp-sv-css';
    st.textContent='.tcp-sv{display:flex!important;width:auto;text-align:right;flex-direction:column;align-items:flex-end;gap:4px;margin-top:4px;font-size:14px;line-height:1.2}'+
      '.tcp-sv s{color:#8A94A0;font-weight:500}'+
      '.tcp-sv b{display:inline-block;background:#E3F6EA;color:#0B7A3B;font-weight:700;font-size:12px;padding:3px 8px;border-radius:999px;white-space:nowrap}'+
      '.tcp-sv-plan{display:block!important;margin-top:4px;font-size:13px;color:#0B7A3B;font-weight:600}'+
      '[data-tcp-savings-row] [data-tcp-v]{color:#0B7A3B!important;font-weight:700!important}';
    document.head.appendChild(st);
  }
  function textNodes(root){var out=[],w=document.createTreeWalker(root,NodeFilter.SHOW_TEXT,null);while(w.nextNode()){var n=w.currentNode;if(n.nodeValue&&n.nodeValue.trim()&&!(n.parentElement&&n.parentElement.closest('.tcp,[data-tcp-sv],[data-tcp-savings-row],script,style')))out.push(n)}return out}
  function norm(t){return String(t||'').replace(/\s+/g,' ').replace(/\s*USD$/i,'').trim()}
  function planLine(pl){
    var a=(pl&&pl.price_adjustments)||[];if(!a.length)return '';
    var pct=function(x){return x&&x.value_type==='percentage'?x.value:null};
    var f=pct(a[0]),t=a[1]?pct(a[1]):f;if(f==null)return '';
    return f===t?(f+'% off every order'):(f+'% off today, then '+t+'% off forever');
  }
  var svBusy=false,svRetry=0;
  function savings(){
    if(svBusy)return;
    var nodes=textNodes(document.body);
    var totalNode=nodes.filter(function(n){return /^total$/i.test(n.nodeValue.trim())})[0];
    if(!totalNode)return;                                          /* drawer not open */
    svBusy=true;
    getCart().then(function(c){
      css();var total=0,used=[],missing=0;
      (c.items||[]).forEach(function(it){
        var a=it.selling_plan_allocation,final=it.final_line_price,compare=0;
        if(a&&a.compare_at_price)compare=a.compare_at_price*it.quantity;
        if(!compare&&it.original_line_price>final)compare=it.original_line_price;
        var save=compare-final;if(save<=0)return;total+=save;
        var sig=it.key+'|'+final+'|'+compare;
        var ex=document.querySelector('[data-tcp-sv="'+CSS.escape(sig)+'"]');if(ex&&ex.isConnected&&ex.parentElement&&norm(ex.parentElement.firstChild&&ex.parentElement.firstChild.nodeValue)===money(final))return;
        $$old(it.key);
        var priceTxt=money(final),title=titleOf(it).slice(0,32),others=othersOf(c,it);
        var totalRow=totalNode.parentElement;while(totalRow&&totalRow.parentElement&&!/\$\s?[\d,]+\.\d{2}/.test(totalRow.textContent))totalRow=totalRow.parentElement;
        var cand=nodes.filter(function(n){
          if(norm(n.nodeValue)!==priceTxt||used.indexOf(n)>-1||/USD/i.test(n.nodeValue))return false;
          if(totalRow&&totalRow.contains(n))return false;                       /* never the cart total */
          var el=n.parentElement;if(!el||!el.offsetParent&&getComputedStyle(el).position!=='fixed')return false;   /* skip hidden copies */
          return true;
        });
        /* pick the price whose closest ancestor holding this product's title is nearest */
        var best=null,bestD=99;
        cand.forEach(function(n){var r=scope(n,title,others);if(r&&r.d<bestD){bestD=r.d;best=n}});
        var hit=best;
        if(!hit){missing++;return}used.push(hit);
        var box=document.createElement('div');box.className='tcp-sv';box.setAttribute('data-tcp-sv',sig);box.setAttribute('data-tcp-key',it.key);
        box.innerHTML='<s>'+money(compare)+'</s><b>'+Math.round(save/compare*100)+'% '+OFF_TXT+'</b>';
        hit.parentElement.appendChild(box);
        var pl=a&&a.selling_plan,txt=planLine(pl);
        var sc=scope(hit,title,others);if(txt&&sc){var e=hit.parentElement;for(var k=0;k<12&&e&&sc.el.contains(e);k++,e=e.parentElement){ var tn=textNodes(e).filter(function(n){return pl&&norm(n.nodeValue)===norm(pl.name)})[0]; if(tn){var sp=document.createElement('span');sp.className='tcp-sv-plan';sp.setAttribute('data-tcp-sv',sig+'|p');sp.setAttribute('data-tcp-key',it.key);sp.textContent=txt;tn.parentElement.appendChild(sp);break} }}
      });
      /* a line still animating in (hidden) gets placed on a short retry */
      if(missing&&svRetry<8){svRetry++;setTimeout(scheduleLabel,350)}else if(!missing)svRetry=0;
      /* drop badges for lines that are gone */
      var keys=(c.items||[]).map(function(i){return i.key});
      Array.prototype.forEach.call(document.querySelectorAll('[data-tcp-key]'),function(el){if(keys.indexOf(el.getAttribute('data-tcp-key'))<0)unwrap(el)});
      /* total savings row, cloned from the drawer's own Total row so it matches its style */
      var old=document.querySelector('[data-tcp-savings-row]'),sigT=String(total);
      if(old&&old.getAttribute('data-tcp-savings-row')===sigT)return;
      if(old)old.remove();
      if(total<=0)return;
      var row=totalNode.parentElement;while(row&&row.parentElement&&!/\$\s?[\d,]+\.\d{2}/.test(row.textContent))row=row.parentElement;
      if(!row||row===document.body)return;
      var clone=row.cloneNode(true);
      var tn=[],cw=document.createTreeWalker(clone,NodeFilter.SHOW_TEXT,null);while(cw.nextNode()){if(cw.currentNode.nodeValue.trim())tn.push(cw.currentNode)}
      clone.setAttribute('data-tcp-savings-row',sigT);
      tn.forEach(function(n){if(/^total$/i.test(n.nodeValue.trim()))n.nodeValue=n.nodeValue.replace(/total/i,SAVE_TXT);else if(/\$\s?[\d,]+\.\d{2}/.test(n.nodeValue)){n.nodeValue=money(total)+' '+OFF_TXT;n.parentElement.setAttribute('data-tcp-v','1')}});
      row.parentElement.insertBefore(clone,row);
    }).catch(function(){}).then(function(){svBusy=false});
  }
  /* nearest ancestor of n that holds this line's title and no other line's title.
     Returns {el,d} or null, so a badge can never land on a neighbour line. */
  function scope(n,title,others){
    var e=n.parentElement;
    for(var d=0;d<12&&e;d++,e=e.parentElement){var tx=(e.textContent||'').toLowerCase();
      if(others.some(function(o){return tx.indexOf(o)>-1}))return null;
      if(tx.indexOf(title)>-1)return {el:e,d:d}}
    return null;
  }
  function titleOf(it){return norm(it.product_title).toLowerCase().slice(0,32)}
  function othersOf(c,it){var t=titleOf(it);return (c.items||[]).map(titleOf).filter(function(x,i,a){return x!==t&&a.indexOf(x)===i})}
  function clearAll(){
    try{Array.prototype.forEach.call(document.querySelectorAll('.tcp-sv-wrap'),unwrap);
    Array.prototype.forEach.call(document.querySelectorAll('.tcp-sv,.tcp-sv-plan,[data-tcp-up],[data-tcp-savings-row]'),function(e){e.remove()})}catch(e){}
  }
  function unwrap(el){if(el.classList.contains('tcp-sv-wrap')){Array.prototype.slice.call(el.childNodes).forEach(function(c){if(!(c.classList&&c.classList.contains('tcp-sv')))el.parentNode.insertBefore(c,el)});}el.remove()}
  function $$old(key){Array.prototype.forEach.call(document.querySelectorAll('[data-tcp-key="'+CSS.escape(key)+'"]'),unwrap)}
  /* ---------- 4) one-time lines: "Subscribe & Save $X" button ---------- */
  var SUB_LABEL='Subscribe & Save';
  function upsellCss(){
    if(document.getElementById('tcp-up-css'))return;
    var st=document.createElement('style');st.id='tcp-up-css';
    st.textContent='.tcp-up{all:unset;box-sizing:border-box;display:flex;align-items:center;justify-content:center;gap:8px;width:100%;margin:12px 0 4px;padding:12px 14px;border-radius:12px;background:#1C2B38;color:#fff;font:800 15px/1.2 Montserrat,"Helvetica Neue",Arial,sans-serif;cursor:pointer;text-align:center;transition:transform .15s,background .15s}'+
      '.tcp-up:hover{background:#25394A}.tcp-up:active{transform:scale(.98)}.tcp-up:focus-visible{outline:2px solid #ED2930;outline-offset:2px}'+
      '.tcp-up b{background:#ED2930!important;color:#fff!important;border-radius:999px;padding:3px 9px;font-size:13px!important;font-weight:800!important}'+'button.tcp-up,.tcp-up,.tcp-up span{color:#fff!important;-webkit-text-fill-color:#fff!important;background-color:#1C2B38!important;font-family:Montserrat,"Helvetica Neue",Arial,sans-serif!important;font-size:15px!important;font-weight:800!important;text-transform:none!important;letter-spacing:0!important;opacity:1!important;text-shadow:none!important;border:0!important;height:auto!important;min-height:0!important;line-height:1.2!important}'+'.tcp-up span{background:transparent!important}'+
      '.tcp-up-note{display:block;text-align:center;font:500 12px/1.3 Roboto,Arial,sans-serif;color:#5B6875;margin:0 0 4px}';
    document.head.appendChild(st);
  }
  function tierPlan(prod,qty){
    var want=Math.min(Math.max(qty,1),MAX_BOXES)*PACKS_PER_BOX,hit=null;
    (prod.selling_plan_groups||[]).forEach(function(g){(g.selling_plans||[]).forEach(function(sp){if(!hit&&planPacks(sp.name)===want)hit=sp})});
    return hit;
  }
  var upBusy=false,upRetry=0;
  function upsell(){
    if(upBusy)return;
    var nodes=textNodes(document.body);
    var totalNode=nodes.filter(function(n){return /^total$/i.test(n.nodeValue.trim())})[0];
    if(!totalNode)return;
    upBusy=true;
    getCart().then(function(c){
      var keys=[],jobs=(c.items||[]).filter(function(it){return !it.selling_plan_allocation}).map(function(it){
        keys.push(it.key);
        return product(it.handle).then(function(prod){
          var pl=tierPlan(prod,it.quantity);if(!pl)return;
          var v=(prod.variants||[]).filter(function(x){return String(x.id)===String(it.variant_id)})[0]||{};
          var al=(v.selling_plan_allocations||[]).filter(function(a){return String(a.selling_plan_id)===String(pl.id)})[0];
          var unit=al?al.price:null;
          if(unit==null){var a0=(pl.price_adjustments||[])[0];if(a0&&a0.value_type==='percentage')unit=Math.round(it.price*(100-a0.value)/100)}
          if(unit==null)return;
          var save=(it.price-unit)*it.quantity;if(save<=0)return;
          var sig=it.key+'|'+it.quantity+'|'+save;
          if(document.querySelector('[data-tcp-up="'+CSS.escape(sig)+'"]'))return;
          Array.prototype.forEach.call(document.querySelectorAll('[data-tcp-up-key="'+CSS.escape(it.key)+'"]'),function(e){e.remove()});
          var priceTxt=money(it.final_line_price),title=titleOf(it).slice(0,32),others=othersOf(c,it),best=null,bestE=null,bestD=99;
          var tr=totalNode.parentElement;while(tr&&tr.parentElement&&!/\$\s?[\d,]+\.\d{2}/.test(tr.textContent))tr=tr.parentElement;
          textNodes(document.body).forEach(function(n){
            if(norm(n.nodeValue)!==priceTxt||/USD/i.test(n.nodeValue)||(tr&&tr.contains(n)))return;
            var r=scope(n,title,others);if(r&&r.d<bestD){bestD=r.d;best=n;bestE=r.el}
          });
          if(!bestE){if(upRetry<8){upRetry++;setTimeout(scheduleLabel,350)}return}upRetry=0;
          upsellCss();
          var wrap=document.createElement('div');wrap.setAttribute('data-tcp-up',sig);wrap.setAttribute('data-tcp-up-key',it.key);
          wrap.innerHTML='<button type="button" class="tcp-up"><span>'+SUB_LABEL+'</span> <b>'+money(save)+'</b></button><span class="tcp-up-note">'+(planLine(pl)||'Monthly delivery')+' \u00b7 Free shipping \u00b7 Cancel anytime</span>';
          wrap.querySelector('button').addEventListener('click',function(ev){
            ev.preventDefault();ev.stopPropagation();showBusy();clearAll();
            j('cart/change.js',{method:'POST',body:JSON.stringify({id:it.key,quantity:it.quantity,selling_plan:pl.id})})
              .then(function(){cart=null;refreshUI()}).catch(function(){}).then(function(){setTimeout(hideBusy,700)});
          });
          bestE.appendChild(wrap);
        });
      });
      Array.prototype.forEach.call(document.querySelectorAll('[data-tcp-up-key]'),function(e){if(keys.indexOf(e.getAttribute('data-tcp-up-key'))<0)e.remove()});
      return Promise.all(jobs);
    }).catch(function(){}).then(function(){upBusy=false});
  }
  var OURS='.tcp-sv,.tcp-sv-plan,[data-tcp-up],[data-tcp-savings-row],.tcp-busy';
  function mine(n){var e=n&&(n.nodeType===1?n:n.parentElement);return !!(e&&e.closest&&e.closest(OURS))}
  function notOurs(r){
    if(mine(r.target))return false;
    if(r.type==='characterData')return true;
    var all=Array.prototype.slice.call(r.addedNodes).concat(Array.prototype.slice.call(r.removedNodes));
    if(!all.length)return false;
    return !all.every(function(n){return n.nodeType===1&&n.matches&&n.matches(OURS+',style')});
  }
  function start(){
    new MutationObserver(function(recs){if(recs.some(notOurs))scheduleLabel()}).observe(document.documentElement,{childList:true,subtree:true,characterData:true});
    ['ocu:cart:open','cart:refresh','cart:updated'].forEach(function(e){window.addEventListener(e,scheduleLabel);document.addEventListener(e,scheduleLabel)});
    label();savings();upsell();guard();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();
